<template>
  <transition name="toast-fade">
    <div v-if="visible" class="toast">
      <div class="toast-icon">🛒</div>
      <div class="toast-message">
        <strong>{{ title }}</strong><br />
        {{ message }}
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    title: String,
    message: String,
    duration: {
      type: Number,
      default: 3000
    }
  },
  data() {
    return {
      visible: false
    };
  },
  mounted() {
    this.visible = true;
    setTimeout(() => (this.visible = false), this.duration);
  }
};
</script>

<style scoped>
.toast {
  position: fixed;
  top: 90px; /* pod headerem, wcześniej było 20px */
  right: 20px;
  background: #111;
  color: #fff;
  padding: 16px 22px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  max-width: 280px;
  font-size: 15px;
}

.toast-icon {
  font-size: 20px;
  margin-top: 2px;
}

.toast-fade-enter-active,
.toast-fade-leave-active {
  transition: opacity 0.4s;
}
.toast-fade-enter-from,
.toast-fade-leave-to {
  opacity: 0;
}
</style>
